import { toolsEndpoints } from "./tools.api"

export const {
  useGetAllToolsQuery,
  useGetActiveToolDetailsQuery,
  useGetToolByIdQuery,
  useBuyToolMutation,
  useEquipToolMutation,
  useGetUpgradeStepsQuery,
  useGetActiveToolQuery,
  usePutRunesIntoToolMutation,
  useBreedToolsMutation,
  useGetFilteredToolsQuery,
  useGetUserToolTypesCountQuery,
  endpoints: {
    getAllTools,
    getActiveToolDetails,
    getActiveTool,
    getToolById,
    putRunesIntoTool,
    breedTools,
    getFilteredTools
  }
} = toolsEndpoints
